import { registerSW } from 'virtual:pwa-register';

const UPDATE_INTERVAL_MS = 60 * 1000;

export function registerSWAutoReload() {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  let hasPendingVisibilityCheck = false;
  let registrationRef;

  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      registrationRef = registration;

      const checkForUpdates = () => {
        registration.update().catch(() => {});
      };

      checkForUpdates();
      window.setInterval(checkForUpdates, UPDATE_INTERVAL_MS);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible' || hasPendingVisibilityCheck) return;

        hasPendingVisibilityCheck = true;
        Promise.resolve()
          .then(checkForUpdates)
          .finally(() => {
            hasPendingVisibilityCheck = false;
          });
      });
    },
    onRegisterError(error) {
      console.error('No se pudo registrar el service worker', error);
    },
  });

  window.addEventListener('online', () => {
    registrationRef?.update().catch(() => {});
  });
}
